/** This is a no-op on the web */
export const useFonts = () => {};
